const MENU_SCRAPING_TEMPLATES_SORTING_CRITERIA = {
  NAME: 'NAME',
  STATUS: 'STATUS',
}

export default MENU_SCRAPING_TEMPLATES_SORTING_CRITERIA
